<template>
    <div v-if="nav.items.length" class="app-sub-nav">
        <a v-for="(item, index) in nav.items" :class="itemClass(item.id)" :key="index" @click="handleClick(item.id)">{{item.title}}</a>
    </div>
</template>

<script>
    import {mapState, mapMutations} from 'vuex'

    export default {
        name: 'header-navigation',
        computed: {
            ...mapState({
                nav: state => state.headerNav,
            })
        },
        methods: {
            ...mapMutations([
                'setHeaderNavActive'
            ]),
            itemClass(id) {
                return this.nav.active === id ? 'active' : ''
            },
            handleClick(id) {
                this.setHeaderNavActive(id)
            }
        }
    }
</script>


<style scoped>
    .app-sub-nav a {
        cursor: pointer;
    }
</style>
